import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';

const namespace = 'ActionSpeedDial';

const Types = {
    mutations: {
        SET_OPEN: 'setOpen',
    },
};

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
